import { APP_NAME } from '@/constants'

/** A full-page wait that continues on its own: a spinner, a title and a line of text. */
function WaitingScreen({ title, children }: { title: string; children: string }) {
  return (
    <div className="flex min-h-screen items-center justify-center bg-default p-4">
      <div
        className="w-full max-w-md rounded-lg border border-default surface-default p-8 text-center shadow-lg"
        role="status"
        aria-live="polite"
      >
        <div
          className="mx-auto h-8 w-8 animate-spin rounded-full border-2 border-info border-t-transparent"
          aria-hidden="true"
        />
        <h1 className="mt-4 text-xl font-semibold text-default">{title}</h1>
        <p className="mt-2 text-sm text-muted">{children}</p>
      </div>
    </div>
  )
}

/**
 * Stands in for the app while it waits for a server that isn't answering
 * (a deploy restarting it, or the connection dropping) and keeps trying on
 * its own; see `isServerUnavailableError`. A calm wait, not an error: the
 * host shows its error screen only once it stops trying.
 */
export function ReconnectingScreen() {
  return (
    <WaitingScreen title={`Reconnecting to ${APP_NAME}`}>
      {`${APP_NAME} may be updating. This usually takes under a minute, and the app will continue on its own.`}
    </WaitingScreen>
  )
}
